import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
// export const IS_ADDING_CHIP = 'IS_ADDING_CHIP';
export const SET_INSERTED_DATA_DISPLAY_MODE = 'SET_INSERTED_DATA_DISPLAY_MODE';
// export const SET_DATA_CHIP_DATA = 'SET_DATA_CHIP_DATA';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	// [IS_ADDING_CHIP](state, payload) {
	// 	Vue.set(state, 'isAddingChip', payload);
	// },
	[SET_INSERTED_DATA_DISPLAY_MODE](state, payload) {
		Vue.set(state, 'insertedDataDisplayMode', payload);
	},
	// [SET_DATA_CHIP_DATA](state, payload) {
	// 	const { dataChipId } = payload;
	// 	const newDataChips = { ...state.dataChips, ...{ [dataChipId]: { ...payload } } };
	// 	Vue.set(state, 'dataChips', newDataChips);
	// },
};

export default mutations;
